import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconPlusCircle = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M20.484,20.485 C18.218,22.752 15.205,24.000 12.000,24.000 C8.795,24.000 5.782,22.752 3.516,20.485 C1.248,18.219 0.000,15.205 0.000,12.000 C0.000,8.795 1.248,5.782 3.516,3.515 C5.781,1.249 8.795,0.000 12.000,0.000 C15.205,0.000 18.219,1.249 20.485,3.516 C22.751,5.782 24.000,8.795 24.000,12.000 C24.000,15.205 22.751,18.219 20.484,20.485 ZM19.070,4.930 C17.182,3.040 14.671,2.000 12.000,2.000 C9.329,2.000 6.818,3.040 4.930,4.930 C3.040,6.819 2.000,9.329 2.000,12.000 C2.000,14.671 3.040,17.182 4.930,19.071 C6.818,20.960 9.329,22.000 12.000,22.000 C14.671,22.000 17.182,20.960 19.070,19.071 C20.959,17.182 22.000,14.671 22.000,12.000 C22.000,9.329 20.959,6.819 19.070,4.930 ZM17.000,13.000 L13.000,13.000 L13.000,17.000 C13.000,17.552 12.552,18.000 12.000,18.000 C11.448,18.000 11.000,17.552 11.000,17.000 L11.000,13.000 L7.000,13.000 C6.448,13.000 6.000,12.552 6.000,12.000 C6.000,11.448 6.448,11.000 7.000,11.000 L11.000,11.000 L11.000,7.000 C11.000,6.448 11.448,6.000 12.000,6.000 C12.552,6.000 13.000,6.448 13.000,7.000 L13.000,11.000 L17.000,11.000 C17.552,11.000 18.000,11.448 18.000,12.000 C18.000,12.552 17.552,13.000 17.000,13.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconPlusCircle.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
